module.exports = __webpack_public_path__ + "static/media/3_AP_NES_Z2.06f4a70a.png";